export const SET_WIDGET_LIST = 'widgets/set-widget-list';
export const SET_SELECTED_WIDGET = 'widgets/set-selected-widget';
export const REMOVE_WIDGET = 'widgets/remove-widget';
export const SET_SELECTED_PARENT_WIDGET = 'widgets/set-selected-parent-widget';
export const REMOVE_PARENT_WIDGET = 'widgets/remove-parent-widget';
export const SET_WIDGETS_TOTAL = 'widgets/set-widgets-total';
export const SET_WIDGET_INFO = 'widgets/set-widget-info';
